import React from 'react';

const LogoTab = ({ company, onLogoUpload }) => {
    return (
        <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-lg font-medium font-montserrat text-gray-900 mb-4">Logo</h2>
            <div className="space-y-4">
                {company?.logo && (
                    <div className="border rounded p-4 bg-gray-50">
                        <p className="text-sm text-gray-600 mb-2">Nuværende logo:</p>
                        <img 
                            src={company.logo} 
                            alt="Company logo" 
                            className="h-20 w-auto"
                        />
                    </div>
                )}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {company?.logo ? 'Upload nyt logo' : 'Upload logo'}
                    </label>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={onLogoUpload}
                        className="block w-full text-sm text-gray-500
                            file:mr-4 file:py-2 file:px-4
                            file:rounded-md file:border-0
                            file:text-sm file:font-semibold
                            file:bg-amber-50 file:text-amber-700
                            hover:file:bg-amber-100"
                    />
                </div>
            </div>
        </div>
    );
};

export default LogoTab;